import React from 'react';
import Alert from "@material-ui/lab/Alert";
import {useDispatch, useSelector} from "react-redux";
import {setSwBookState} from "../../../../../store/reducers/search-widget";
import {Grid, useMediaQuery, useTheme, Snackbar} from "@material-ui/core";

const BookAlertConnected = () => {

    const {breakpoints} = useTheme();
    const isMobile = useMediaQuery(breakpoints.down('sm'));
    const multiCityAlertMessage = useSelector(state => state.sw.book.multiCityAlertMessage);
    const dispatch = useDispatch();

    if (!multiCityAlertMessage) return null;

    if (isMobile) {
        return (
            <Snackbar autoHideDuration={6000} anchorOrigin={{vertical: 'top', horizontal: 'right'}} onClose={() => dispatch(setSwBookState({multiCityAlertMessage: null}))} open>
                <Alert onClose={() => dispatch(setSwBookState({multiCityAlertMessage: null}))} {...multiCityAlertMessage}/>
            </Snackbar>
        );
    }

    return (
        <Grid xs={12} sm={12} item>
            <Alert onClose={() => dispatch(setSwBookState({multiCityAlertMessage: null}))} {...multiCityAlertMessage}/>
        </Grid>
    );
};

export default BookAlertConnected;